function readOptionalString(value: unknown) {
  const text = String(value ?? "").trim()
  return text ? text : null
}

function isGenericProfileName(value: string | null) {
  const normalized = String(value || "").trim().toLowerCase()
  if (!normalized) return true
  return normalized === "unknown creator" || normalized === "village member" || normalized === "unknown member"
}

export function resolveCanonicalProfileName(input: {
  full_name?: unknown
  fullName?: unknown
  display_name?: unknown
  displayName?: unknown
  username?: unknown
  email?: unknown
  fallbackName?: unknown
  defaultName?: unknown
}) {
  const candidates = [
    readOptionalString(input.full_name),
    readOptionalString(input.fullName),
    readOptionalString(input.display_name),
    readOptionalString(input.displayName),
    readOptionalString(input.username),
    readOptionalString(input.email),
    readOptionalString(input.fallbackName),
  ]

  for (const candidate of candidates) {
    if (!candidate || isGenericProfileName(candidate)) continue
    return candidate
  }

  return readOptionalString(input.defaultName) || "Creator"
}

export function resolveCanonicalProfileAvatar(input: {
  profile_photo?: unknown
  profilePhoto?: unknown
  avatar_url?: unknown
  avatarUrl?: unknown
}) {
  return (
    readOptionalString(input.profile_photo)
    || readOptionalString(input.profilePhoto)
    || readOptionalString(input.avatar_url)
    || readOptionalString(input.avatarUrl)
    || null
  )
}

export function hasExplicitProfileFullName(input: {
  full_name?: unknown
  fullName?: unknown
}) {
  return Boolean(readOptionalString(input.full_name) || readOptionalString(input.fullName))
}

export function hasUsableCanonicalProfileName(input: {
  full_name?: unknown
  fullName?: unknown
  display_name?: unknown
  displayName?: unknown
  username?: unknown
  email?: unknown
  fallbackName?: unknown
}) {
  const resolved = resolveCanonicalProfileName({ ...input, defaultName: "" })
  return Boolean(readOptionalString(resolved))
}
